<template>
  <section id="key-of-success" class="key-of-success">
    <div class="background-container">
      <!-- Contenedor para el fondo -->
    </div>
    
    <div class="content-container">
      <div class="content">
        <div class="title-section">
          <h1>{{ translate('landing.the_key', 'THE KEY') }}<br>{{ translate('landing.of_success', 'OF SUCCESS') }}</h1>
        </div>

        <div class="description-section">
          <p class="main-description">
            {{ translate('landing.key_description_1', 'PawPulse automates feedback collection, monitors customer sentiment, and helps businesses resolve complaints before they become problems.') }} <br>
            {{ translate('landing.key_description_2', 'With real-time SMS surveys and instant escalation of negative feedback, PawPulse ensures your business stays ahead of customer expectations.') }}
          </p>
        </div>

        <div class="features-section">
          <h2 class="subtitle">{{ translate('landing.description', 'DESCRIPTION') }}</h2>
          <div class="features-columns">
            <div class="column">
              <p class="feature-item">
                <span class="number">1</span>
                <span>{{ translate('landing.feature_1', 'Automatic customer satisfaction survey') }}</span>
              </p>
              <p class="feature-item">
                <span class="number">2</span>
                <span>{{ translate('landing.feature_2', 'Instant alerts for negative feedback') }}</span>
              </p>
            </div>
            <div class="column">
              <p class="feature-item">
                <span class="number">3</span>
                <span>{{ translate('landing.feature_3', 'Seamless complaint resolution process') }}</span>
              </p>
              <p class="feature-item">
                <span class="number">4</span>
                <span>{{ translate('landing.feature_4', 'Boost customer loyalty & retention') }}</span>
              </p>
            </div>
          </div>
        </div>

        <div class="cta-section">
          <button class="cta-button button" @click="$router.push('/home')">{{ translate('landing.get_demo', 'GET A DEMO') }}</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useStore } from 'vuex'

export default {
  name: 'TheKeyOfSuccess',
  setup() {
    const store = useStore()
    
    const translate = (key, fallback) => {
      const translations = store.state.translations
      const parts = key.split('.')
      
      let value = translations
      for (const part of parts) {
        if (value && value[part]) {
          value = value[part]
        } else {
          return fallback
        }
      }
      
      return typeof value === 'string' ? value : fallback
    }
    
    return {
      translate
    }
  }
}
</script>

<style scoped>
/* Las clases h1, h2, h3, p ahora vienen desde App.vue */
:root, body, * {
  font-family: var(--font-primary) !important;
}

:root {
  /* Variables globales si son necesarias */
}

.key-of-success {
  position: relative;
  width: 100%;
  display: grid;
  grid-template-rows: 1fr;
  color: white;
  overflow: hidden;
}

/* Contenedor para el fondo */
.background-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/technopawsImages/theKeyOfSucces.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #095d6e; /* Color de fondo que extiende la imagen */
  z-index: 1;
}

/* Usa la clase .content-container global definida en App.vue */
.content-container {
  /* Solo mantenemos propiedades específicas de este componente */
  padding-top: 5rem;
}

.content {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2rem;
  margin-top: calc(40vh + 80px); /* Ajustado para dar espacio al header y la vista de imagen */
  background-color: rgba(9, 93, 110, 0.8); /* Fondo semitransparente */
  backdrop-filter: blur(5px);
  border-radius: 15px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.2);
}

.title-section h1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  text-align: center;
}

.description-section {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

.main-description {
  line-height: 1.6;
}

.features-section {
  padding: 0rem;
}

.subtitle {
  text-align: center;
  margin-bottom: 2rem;
}

.features-columns {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  justify-content: center;
}

.column {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0.1);
  padding: 1rem;
  border-radius: 10px;
  transition: transform 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-5px);
  background-color: rgba(255, 255, 255, 0.2);
}

.number {
  background-color: #f5a361;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.cta-section {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}

.cta-button {
  background-color: #f3a261;
  /* El resto de propiedades ahora vienen de la clase global cta-button */
}

/* Media queries para móviles pequeños */
@media (max-width: 480px) {
  /* Los media queries para móvil ahora están en App.vue */
  .content-container {
  /* Solo mantenemos propiedades específicas de este componente */
  padding-bottom: 2rem;
  }
  .content {
    margin-top: 38vh;
    padding: 1rem 1rem;
    max-width: 100%;
  }
  
  .features-columns {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .main-description {
    text-align: left;
    line-height: 1.6
  }
  
  .number {
    padding: 1rem;
  }

  .features-section {
    padding-top: 1rem;
  }

  .feature-item {
    padding: 0.8rem;
  }
}
</style>
